<template>
  <div class="fangXQ">
    <topNav :title="$t('fangXQ_title')"
            url="/fangQ"></topNav>

    <div class="ssearch">
      <div style="float:left">
        <datepik @change='dateChange'
                 ref="datepik"
                 limit="next"
                 :defaultValue="currentDate"
                 step="1"></datepik>
      </div>
      <div class="right">
        {{$t('orderFromReport_choose')}}
        <select v-model="zb"
                @change="drawChart"
                class="options">
          <option v-for="(item,key) in zbList"
                  :value="key"
                  :key="key">{{item}}
          </option>
        </select>
      </div>
    </div>

    <div id="chart">
    </div>

    <template v-if='fangXqModeIsType'>
      <div class="ind">
        <div class="formTop">
          <!--  房型-->
          <div class="topOne"
               style="width:20%">{{$t('fangXQ_rmtype')}}
          </div>
          <!--  总房数-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_total_num')}}
          </div>
          <!--  可售-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_available')}}
          </div>
          <!--  占用-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_takeup')}}
          </div>
          <!--  维修-->
          <div class="topOne"
               style="width:12.3%">{{$t('fangQ_maintenance')}}
          </div>
          <!--  均价-->
          <div class="topOne"
               style="width:12.3%">{{$t('fangQ_average_price')}}
          </div>
          <!--  出租率-->
          <div class="topOne"
               style="width:17.8%">{{$t('fangQ_rents')}}
          </div>
        </div>
        <div class="conditionList">
          <div class="tbodyH">
            <div v-for='(item,index) in typeList'>
              <ul @click='toggleTypeDetail(item)'
                  :key="index"
                  v-if='index != 0'
                  style="background:#f5f5f5; width: 100%">
                <li style='width: 20%;'>
                  <div style='display: flex;align-items: center;padding-left: 3px;'>
                    <i class='iconfont icon-jian1'
                       v-if='item.showTypeDetail'
                       style='font-size: 12px;font-weight: bold;color: #666;padding-right: 3px;'></i>
                    <i class='iconfont icon-jia'
                       v-else
                       style='font-size: 12px;color: #666;padding-right: 3px;'></i>
                    {{fSum(item.des)}}
                  </div>
                </li>
                <li style='width: 12.5%'>
                  {{item.roomCount}}
                </li>
                <li style='width: 12.5%'>
                  {{item.inLive}}
                </li>
                <li style='width: 12.5%'>
                  {{item.inReservation}}
                </li>
                <li style='width: 12.3%'>
                  {{item.inRemain}}
                </li>
                <li style='width: 12.3%'>
                  {{item.avg}}
                </li>
                <li style='width: 17.8%'>
                  {{item.rate}}
                </li>
              </ul>

              <ul v-for='(item2,index2) in item.list'
                  v-show='item.showTypeDetail || index == 0'
                  :style="{'background':(index==0)?'#F7EF8C':''}"
                  :key="item2.roomType + index2">
                <li style='width: 20%;'>
                  <div style='text-align: center;'>
                    {{fSum(item2.roomType)}}
                  </div>
                </li>
                <li style='width: 12.5%'>
                  {{item2.roomCount}}
                </li>
                <li style='width: 12.5%'>
                  {{item2.inLive}}
                </li>
                <li style='width: 12.5%'>
                  {{item2.inReservation}}
                </li>
                <li style='width: 12.3%'>
                  {{item2.inRemain}}
                </li>
                <li style='width: 12.3%'>
                  {{item2.avg}}
                </li>
                <li style='width: 17.8%'>
                  {{item2.rate}}
                </li>
              </ul>
            </div>
            <li style="width:100%;height:0.8rem;"></li>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="ind">
        <div class="formTop">
          <!--  房型-->
          <div class="topOne"
               style="width:20%">{{$t('fangXQ_rmtype')}}
          </div>
          <!--  总房数-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_total_num')}}
          </div>
          <!--  可售-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_available')}}
          </div>
          <!--  占用-->
          <div class="topOne"
               style="width:12.5%">{{$t('fangXQ_takeup')}}
          </div>
          <!--  维修-->
          <div class="topOne"
               style="width:12.3%">{{$t('fangQ_maintenance')}}
          </div>
          <!--  均价-->
          <div class="topOne"
               style="width:12.3%">{{$t('fangQ_average_price')}}
          </div>
          <!--  出租率-->
          <div class="topOne"
               style="width:17.8%">{{$t('fangQ_rents')}}
          </div>
        </div>
        <table class="conditionList"
               align='center'
               style="border-collapse:collapse;width: 100%;table-layout: fixed;">
          <tbody class="tbodyH">
            <tr v-for='(item,index) in detailList'
                width="80px"
                :key="index"
                :style="{'background':(index==0)?'#F7EF8C':''}">
              <td width="20%">
                {{fSum(item.roomType)}}
              </td>
              <td width="12.4%">
                {{item.roomCount}}
              </td>
              <td width="12.4%">
                {{item.inLive}}
              </td>
              <td width="12.4%">
                {{item.inReservation}}
              </td>
              <td width="12.4%">
                {{item.inRemain}}
              </td>
              <td width="12.4%">
                {{item.avg}}
              </td>
              <td width="18%">
                {{item.rate}}
              </td>
            </tr>
            <tr style="width:100%;height:0.8rem;"></tr>
          </tbody>
        </table>
      </div>
    </template>

    <div class="toggleBtn"
         @click='toggleShowMode'>
      <span v-if='fangXqModeIsType'>
        {{$t('fangXQ_toogle_detail')}}
      </span>
      <span v-else>
        {{$t('fangXQ_toogle_type')}}
      </span>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import echarts from 'echarts';
  import _ from 'lodash';
  import {Toast} from 'mint-ui';

  export default {
    data() {
      return {
        typeList: [],
        detailList: [],
        currentDate: moment(this.$route.query.date).format('YYYY-MM-DD'),
        formPosition: false,
        language: this.$getLanguage(),
        zb: 'roomCount',
        zbList: {
          roomCount: this.$t('fangXQ_total_num'),
          inLive: this.$t('fangXQ_available'),
          inReservation: this.$t('fangXQ_takeup'),
          inRemain: this.$t('fangQ_maintenance'),
          avg: this.$t('fangQ_average_price'),
          rate: this.$t('fangQ_rents'),
        },
        fangXqModeIsType: localStorage.getItem('fangXqModeIsType') == 'TYPE',
        showDetailChart: localStorage.getItem('fangXqModeIsType') != 'TYPE'
      };
    },
    mounted() {
      this.getData();
      this.$refs.datepik.setDate(this.currentDate);
    },
    methods: {
      toggleShowMode() {
        this.fangXqModeIsType = !this.fangXqModeIsType
        let temp = this.fangXqModeIsType ? 'TYPE' : 'DETAIL'
        this.showDetailChart = !this.fangXqModeIsType
        localStorage.setItem('fangXqModeIsType', temp)
        this.getData()
      },

      toggleTypeDetail(item) {
        item.showTypeDetail = !item.showTypeDetail

        // 有任何一项被展开的话就直接展示详情的图表
        let typeList = this.typeList ||  []
        let showDetailChart = false
        typeList.map((item, index) => {
          if (item.showTypeDetail){
            showDetailChart = true
          }
        })
        this.showDetailChart = showDetailChart
        this.drawChart()
      },

      getData() {
        let showType =  this.fangXqModeIsType
        let url = showType ? '/mobilepmsapi/reception/getRoomSituationDetailByRoomClass' : "/mobilepmsapi/reception/getRoomSituationDetail"
        this.$http
          .post(url, {
            d: this.currentDate
          })
          .then(res => {
            if (res.data.result == 0) {
              let temp = res.data.retVal || []
              if(showType){
                let detailList = []
                temp.map((item, index) => {
                  item.showTypeDetail = false
                  detailList = detailList.concat(item.list || [])
                })
                this.typeList = temp;
              } else {
                this.detailList = temp;
              }
              this.drawChart()
            } else {
              Toast({
                message: res.data.msg,
                position: 'middle',
                duration: 3000
              });
            }
          });
      },
      drawChart() {
        var echartFs = lib.flexible.rem2px([0.3]);
        document.getElementById('chart').style.width = window.innerWidth + 'px';
        var myChart = echarts.init(document.getElementById('chart'), 'customed');
        // 绘制图表
        var data = [];
        var option = {};
        let zb = this.zb

        let dataList = this.detailList || []
        if (!this.showDetailChart){
          dataList = this.typeList
        }

        for (var i = 1; i < dataList.length; i++) {
          var d = dataList[i] || {};
          let namePreFix = d.roomType
          if (!this.showDetailChart){
            namePreFix = d.des
          }

          if (this.zb == 'rate') {
            let rateNum = Number(d[this.zb].substr(0, d[this.zb].length - 1) || '')
            data.push({
              value: rateNum,
              name: namePreFix + ':' + d[this.zb]
            });
          } else {
            // 饼图去掉为0的项
            if (zb == 'avg' || zb == 'rate') {
              data.push({
                value: d[this.zb],
                name: namePreFix + ':' + d[this.zb]
              });
            } else {
              if (d[this.zb]) {
                data.push({
                  value: d[this.zb],
                  name: namePreFix + ':' + d[this.zb]
                });
              }
            }
          }
        }
        if (zb == 'avg' || zb == 'rate') {
          let tempName = 'roomType'
          if (!this.showDetailChart){
            tempName = 'des'
          }
          let dataAxis = _.map(dataList, tempName)
          dataAxis.splice(0, 1)
          option = {
            title: {
              show: false,
            },
            grid: {
              y: '5%',
              x2: '5%',
              x: '14%'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true
                }
              }
            },
            xAxis: {
              data: dataAxis,
              type: 'category',
              'axisLabel': {
                'interval': 0,
                rotate: 45,
                textStyle: {
                  fontSize: 10
                }
              },
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                type: 'bar',
                data: data,
              }
            ],
          }
        } else {
          option = {
            series: [
              {
                type: 'pie',
                radius: '50%',
                center: ['50%', '50%'],
                roseType: 'angle',
                data: data,
                itemStyle: {
                  normal: {
                    label: {
                      textStyle: {
                        fontSize: echartFs
                      }
                    }
                  }
                }
              }
            ]
          };
        }

        myChart.setOption(option, true);
      },
      dateChange(time) {
        this.currentDate = time
        this.getData();
      },
      fSum(v) {
        return this.language == 'zh_CN' ? v : ('合计' == v ? this.$t('fangTXQ_total') : v);
      }
    },
    components: {}
  };
</script>

<style lang='less'>
  .fangXQ {
    overflow: auto;

    .ssearch {
      padding: 10px 15px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    #chart {
      width: 10rem;
      margin: 0 auto;
      height: 232px;
      box-sizing: border-box;
    }

    .formTopFix {
      position: fixed;
      top: 1.04rem;
      z-index: 200;
    }

    .toggleBtn {
      position: fixed;
      bottom: 80px;
      right: 0px;
      width: 30px;
      height: 80px;
      background: #ffa756;
      color: #fff;
      text-align: center;
      z-index: 10;
      border-radius: 8px 0 0 8px;
      align-items: center;
      display: flex;
      justify-content: space-around;

      > span {
        display: inline-block;
        line-height: 16px;
        width: 20px;
      }

      &:active {
        background: darken(#ff8000, 5%)
      }

      .iconfont {
        line-height: 45px;
        font-size: 20px;
      }
    }

    .ind {
      overflow-y: scroll;
      position: fixed;
      top: 330px;
      bottom: 0;
      width: 100%;
      -webkit-overflow-scrolling: touch;
    }

    .formTop {
      width: 100%;
      clear: both;
      position: fixed;
      top: 329px;
      z-index: 100;

      .topOne {
        height: 1.06666667rem;
        color: #fff;
        background-color: #f69c2d;
        text-align: center;
        line-height: 1.0133rem;
        float: left;
        font-size: 0.34666667rem;
        font-weight: bold;
        padding: 0;
      }
    }

    .conditionList {
      width: 100%;
      margin-top: 1rem;

      ul {
        background-color: #fff;
        font-size: 0.32rem;
        display: flex;
        align-items: center;

        li {
          word-wrap: break-word;
          text-align: center;
          padding: 13px 0px;
          display: inline-block;

          p {
            margin: 0;
          }
        }
      }

      tr {
        background-color: #fff;
        font-size: 0.32rem;

        &:nth-of-type(2n-1) {
          background-color: #f5f5f5;
        }

        td {
          // height: 1.06666667rem;
          word-wrap: break-word;
          text-align: center;
          padding: 13px 0px;

          p {
            margin: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// fangXQ.vue?385656f5